module.exports = __webpack_public_path__ + "static/media/bass.57545fd7.mp3";